module.exports = __webpack_public_path__ + "static/culture-mobile.d2eb1df7.webp";